<template>
  <div class="flex flex-col gap-8 mt-16">
    <div class="flex justify-between">
      {{ title }}
      <div v-if="editable" class="cursor-pointer text-primary-500" @click="$emit('add', title)">Add</div>
    </div>
    <div>
      <div v-for="step in steps" :key="step" class="border border-gray-100 rounded-8 p-8">
        <div :title="step.name" class="flex flex-col gap-8">
          <div class="flex justify-between items-center">
            <p class="font-semibold truncate max-w-200" :title="step.name">{{ step.name }}</p>
            <div class="flex">
              <p class="">{{ $formatTwoDecimalPlaces(step.co2) }}</p>
              <p class="text-gray-400 pl-4">kg CO<sub>2</sub>-eq</p>
            </div>
          </div>
          <div>
            <div class="flex justify-start items-center mb-2 gap-8 text-11">
              <span class="text-gray-600">Energy Consumption</span>
              <span>{{ $formatTwoDecimalPlaces(step.co2) }} </span>
            </div>
            <div class="flex w-[3px] h-[3px] bg-gray-400 rounded-full" />
            <div class="flex justify-start items-center mb-2 gap-8 text-11">
              <span class="text-gray-600">Consumables</span>
              <span>-</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import { mapState } from 'vuex';

import ProcessStep from '@/components/PartWorkflow/ProcessChain/ProcessStep.vue';

export default {
  name: 'MaterialStepGroup',

  components: { ProcessStep, draggable },

  props: {
    title: { type: String, default: '' },
    color: { type: String, default: '' },
    steps: { type: Object, default: () => {} },
    level: { type: Object, default: () => {} },
    property: { type: String, default: '' },
    editable: { type: Boolean },
  },

  emits: ['add'],

  computed: {
    ...mapState('application', ['axiosInstance']),
  },
};
</script>
